import React from "react";

import {
  FaShareAlt,
  FaVoteYea,
  FaTachometerAlt,
  FaShieldAlt,
  FaBalanceScale,
  FaExpandArrowsAlt,
} from "react-icons/fa";

function GossipProtocol() {
  const services = [
    {
      title: "Gossip Protocol",
      desc: "Hedera’s unique protocol enables quick data sharing across nodes, ensuring high network performance and reliability.",
      icon: <FaShareAlt />,
    },
    {
      title: "Virtual Voting",
      desc: "Virtual voting allows nodes to achieve consensus without traditional voting, increasing efficiency and security.",
      icon: <FaVoteYea />,
    },
    {
      title: "High Throughput",
      desc: "Capable of handling 250,000+ transactions per second, Hedera Hashgraph is designed for low latency and high scalability, ideal for large-scale applications.",
      icon: <FaTachometerAlt />,
    },
    {
      title: "Enhanced Security",
      desc: "Using an Asynchronous Byzantine Fault Tolerant (aBFT) model, Hedera Hashgraph achieves secure consensus even under adversarial conditions.",
      icon: <FaShieldAlt />,
    },
    {
      title: "Fairness",
      desc: "The platform ensures fair transaction ordering and timestamps, fostering transparency and trust.",
      icon: <FaBalanceScale />,
    },
    {
      title: "Scalability",
      desc: "Hedera’s Java SDK and DAG structure allow it to scale effortlessly with transaction demand.",
      icon: <FaExpandArrowsAlt />,
    },
  ];

  return (
    <section className="defi-section">
      <div className="container">
        {/* HEADER */}
        <div className="defi-header">
          <h4 className="defi-subtitle">Our Capabilities</h4>
          <h2 className="defi-title">Key Features of Hedera Hashgraph</h2>
        </div>

        {/* GRID */}
        <div className="defi-grid">
          {services.map((service, index) => (
            <div className="defi-card" key={index}>
              <div className="card-glow"></div>

              <div className="defi-icon">{service.icon}</div>

              <h5 className="defi-card-title">{service.title}</h5>
              <p className="defi-card-desc">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default GossipProtocol;
